<template>
  <v-dialog :value="open" :width="getCommDetail.kind === 'voice' ? 1000 : 650" persistent>
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <span>Comm Detail</span>
        <v-btn v-if="getCommDetail.kind === 'voice'" small color="primary" :loading="getDownloadFreshdeskRecordingLoading" :disabled="!getCommDetail.recording_url" @click="downloadFreshdeskRecording(getCommDetail.recording_url)">Download Recording</v-btn>
      </v-card-title>
      
      <v-card-text>
        <CommVoiceView v-if="getCommDetail.kind === 'voice'" />
        <CommDefaultView v-else />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-end">
        <v-btn color="primary" small outlined :disabled="getDownloadFreshdeskRecordingLoading" @click="close">CLOSE</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapMutations, mapGetters, mapActions } from 'vuex';
  import { mdiAlertCircle } from '@mdi/js';
  import CommDefaultView from './CommDefaultView';
  import CommVoiceView from './CommVoiceView';

  export default {
    props: ['open'],

    components: {
      CommDefaultView,
      CommVoiceView,
    },

    data() {
      return {
        mdiAlertCircle,
      }
    },

    computed: {
      ...mapGetters('comms', ['getCommDetail', 'getDownloadFreshdeskRecordingLoading']),
    },
    
    methods: {
      ...mapActions('comms', ['downloadFreshdeskRecording']),
      ...mapMutations('comms', ['SET_COMM_DETAIL']),

      close() {
        this.SET_COMM_DETAIL({});
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>